<template>
    <template v-if="status.app === 'loaded'">
        <div class="row template-container
">
            <div class="col-4">
                <div class="form component-section">
                    <div class="component-wrapper">
                        <div class="component-item" v-for="template in templates" v-if="Object.keys(templates).length !== 0">
                            <button class="btn"
                                    :class="chosenTemplate.id === template.id ? 'btn-primary' : 'btn-secondary'"
                                    @click="chooseTemplate(template)">Plantilla #{{ template.id }} -
                                {{ template.display_name }}
                            </button>
                        </div>

                        <div v-else>No existen plantillas... Podrías crear una.</div>
                    </div>
                </div>
            </div>

            <div class="col-8">
                <div class="form component-section">
                    <div class="row">
                        <div class="col-12">
                            <div class="component-section d-flex justify-content-between" v-if="can('template.update') || can('template.store')">
                                <router-link class="btn btn-edition"
                                             :to="{ name: 'template.update', params: { template: chosenTemplate.id } }"
                                             v-if="can('template.update') && !!chosenTemplate.id">
                                    <h3>Plantilla #{{ chosenTemplate.id }} - {{ chosenTemplate.display_name }}</h3>
                                    <i class="uq-icon bi-search"></i>
                                </router-link>

                                <button class="btn btn-primary"
                                        @click="modal_to_show = 'add-template'"
                                        title="Crear nueva plantilla"
                                        v-if="can('template.store')">
                                    <span>Crear plantilla</span>
                                </button>
                            </div>
                        </div>
                        <div class="col-12" v-if="can('template.store')">
                            <div class="col-12" v-if="!!chosenTemplate.id">
                                Haz clic en el nombre de la plantilla para editarla. Esta plantilla está asignada a los siguientes roles:
                                <span class="badge bg-dark" v-for="role in chosenTemplate.allowed_roles">{{ role }}</span>
                            </div>

                            <div v-else>
                                No existe ninguna plantilla.
                            </div>
                        </div>
                        <div class="col-12" v-if="!!chosenTemplate.id">
                            <template v-if="loading_template_attrs">
                                <div class="loader"></div>
                            </template>
                            <template v-else>
                                <pdf-previewer height="85vh" width="100%" :src="pdf_preview_content"></pdf-previewer>
                            </template>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <templates-list-add-modal v-if="modal_to_show === 'add-template'"
                                  @close="this.modal_to_show = null; getTemplates()"></templates-list-add-modal>
    </template>
    <div class="loader" v-else></div>
</template>

<script>

import router from "../../../router";
import PdfPreviewer from "../parts/PdfPreviewer";
import {getAvailableTemplates, getTemplate} from "../../../helpers/requests/RequestsTemplates";
import TemplatesListAddModal from "./parts/TemplatesListAddModal";
import {can} from "../../../helpers/Permissions";
import {htmlToRawPreviewablePdf} from "../../../helpers/requests/RequestsPDFs";

export default {
    name: "TemplateDataPage",
    components: {
        TemplatesListAddModal,
        PdfPreviewer
    },
    props: {},
    data() {
        return {
            status: {
                app: 'loading',
                data: 'stored',
            },

            modal_to_show: null,

            loading_template_attrs: false,
            templates: [],
            chosenTemplate: {},
            pdf_preview_content: ''
        }
    },
    async mounted() {
        await this.loadTemplates();
        this.status.app = 'loaded';
    },
    methods: {
        async loadTemplates() {
            this.templates = await getAvailableTemplates(true);
            if (this.templates.length > 0) {
                await this.chooseTemplate(this.templates[0]);
            }
        },
        async chooseTemplate(template) {
            this.chosenTemplate = template;

            if (this.loading_template_attrs) return;
            this.loading_template_attrs = true;

            const template_attrs = await getTemplate(this.chosenTemplate.id);
            
            let html = template_attrs.content;
            // We force to push header and footer if existing
            if (!!template.header) {
                html = this.chosenTemplate.header + html;
            }
            if (!!template.footer) {
                html += this.chosenTemplate.footer;
            }

            const pdf_content = await htmlToRawPreviewablePdf(html);
            this.pdf_preview_content = "data:application/pdf;base64," + escape(pdf_content);

            this.loading_template_attrs = false;
        }
    },
    setup() {
        return {
            getAvailableTemplates,
            getTemplate,
            can,

            router,
        }
    }
}
</script>
